import { render, staticRenderFns } from "./ImsGroupSearchDialog.vue?vue&type=template&id=f06eb0b8&scoped=true&"
import script from "./ImsGroupSearchDialog.vue?vue&type=script&lang=js&"
export * from "./ImsGroupSearchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06eb0b8",
  null
  
)

export default component.exports